export default {
      id: "broadcast-icon-usage",
      viewBox: "0 0 28 21",
      url: __webpack_public_path__ + "sprite.svg#broadcast-icon",
      toString: function () {
        return this.url;
      }
    }